import React, { useState } from 'react'
import styles from './ArticleHeader.module.scss'
import Author from 'components/author/Author'
import { EmailShareButton, FacebookShareButton, XShareButton, LinkedinShareButton } from 'react-share'
import { ArticleHeaderProps } from '../types'
import { Button, Heading, Icon } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'

const ArticleHeader = ({ author, messageShareText, tag, title }: ArticleHeaderProps) => {
  const url = typeof window !== 'undefined' ? window.location.href : ''

  //i18n
  const { t } = useTranslation('blog')

  // Local state
  const [linkCopied, setLinkCopied] = useState<boolean>(false)

  /**
   * Copies the referralLink to the users clipboard
   */
  const copyToClipboard = () => {
    setLinkCopied(true)

    if (navigator.clipboard) {
      void navigator.clipboard.writeText(url)
      return
    }

    const textArea = document.createElement('textarea')
    textArea.value = url
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }

  return (
    <section className={styles['article-header']}>
      <strong className="h5 serif mb-100">{tag}</strong>
      <Heading as="h1">{title}</Heading>

      <div className={styles['meta-container']}>
        <Author {...author} />

        <div className={styles['socials-container']}>
          <small className={styles.label}>{t(($) => $.header.share)}</small>

          <div className="flex-row">
            <EmailShareButton className={styles['button-share']} resetButtonStyle={false} url={url} body={messageShareText || title}>
              <Icon name="envelope" />
            </EmailShareButton>
            <XShareButton className={styles['button-share']} resetButtonStyle={false} url={url} text={messageShareText || title}>
              <Icon name="x" />
            </XShareButton>
            <FacebookShareButton className={styles['button-share']} resetButtonStyle={false} url={url}>
              <Icon name="facebook" />
            </FacebookShareButton>
            <LinkedinShareButton className={styles['button-share']} resetButtonStyle={false} url={url}>
              <Icon name="linkedinSquare" />
            </LinkedinShareButton>
            <Button leadingIcon={linkCopied ? 'check' : 'link'} className={styles['button-share']} onClick={copyToClipboard} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ArticleHeader
